import * as angular from 'angular';
import * as Widgets from '../../widgets';

import { ComponentDefinition } from '../../models';
import { DashboardThumbnailWidget } from './dashboardThumbnail.widget';
import { IWidget } from '../../widgets/models';
import { refreshClick } from '../../common';

class DashboardThumbnailController implements angular.IComponentController {
    isLoading: boolean;
    loadingMessage: string;
    item: DashboardThumbnailWidget;
    url: string;
    title: string;
    widgets: IWidget[];

    static $inject = ['$scope', 'widgetFactory'];

    constructor(private _$scope: angular.IScope,
        private _widgetFactory: Widgets.IWidgetFactory) {
    }

    $onInit() {
        if (this.item) {
            const configuration = this.item.configuration;
            this.title = this.item.name;

            const widgets = configuration.widgets.sort(d => d.row);
            widgets.forEach((w: any) => {
                const totalWidth = (w.sizeX * 100 / 12);
                const left = w.col / 12 * 100;
                w.style = {
                    width: totalWidth + '%',
                    left: left + '%'
                };

                w.bodyStyle = {
                    'font-size': w.sizeY <= 2 ? '1em' : '2em'
                };
                w.classed = {};
                w.classed[this.getWidgetClass(w.type)] = true;
            });
            this.widgets = widgets;

            this._$scope.$on(refreshClick, () => {
                this.widgets.forEach((w: any) => {
                    if (w.readData) {
                        w.readData();
                    }
                });
            });
        }
    }

    private getWidgetClass(type: string): string {
        let result = '';
        const miniature = this._widgetFactory.getMiniature(type);
        if (miniature) {
            result = miniature.icon;
        }
        return result;
    }
}

export const wtDashboardThumbnail: ComponentDefinition = {
    componentId: 'wtDashboardThumbnail',
    controller: DashboardThumbnailController,
    template: require('./dashboardThumbnail.component.html'),
    controllerAs: 'vm',
    bindings: {
        item: '<'
    }
};
